import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers } from 'recompose'

import {getQueryStringParams} from 'utils/routes'

import * as routeActions from 'actions/routeActions'
import * as userActions from 'actions/userActions'

export default compose(
  connect(
    (state) => {
      const queryParams = getQueryStringParams(idx(state, _ => _.router.location.search))
      
      return {
        hasError: idx(state, _ => _.progress.reset.hasError) || false,
        errorMessage: idx(state, _ => _.progress.reset.error.message) || null,
        resetSuccess: (!idx(state, _ => _.progress.reset.hasError) && idx(state, _ => _.progress.reset.hasLoaded)) || false,
        token: queryParams && queryParams.token ? queryParams.token : '',
      }
    },
    (dispatch) => {
      const actions = {
        ...routeActions,
        ...userActions,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  // Handlers
  withHandlers({
    onReset: props => (email) => {
      props.actions.resetPassword(email, props.token)
    },
    goToLogin: props => () => {
      props.actions.redirect('/login')
    },
    goToReset: props => () => {
      props.actions.redirect('/reset')
    },
  }),
)



// WEBPACK FOOTER //
// ./src/containers/account/NewPassword/NewPassword.enhancer.js